import { Navigate } from "react-router-dom";
import { usePrescriptionDetectorAuth } from "./PrescriptionDetectorAuthProvider";

const PresDectPrivateRoute = ({ children }) => {
    const { isPresDectAuthenticated } = usePrescriptionDetectorAuth();

    if (!isPresDectAuthenticated) {
        return <Navigate to="/prescription/login"/>
    }

    return children;
}


export default PresDectPrivateRoute;